import React, { Component } from 'react';
import { ComponentType } from 'react';
import { PhoneIcon, RadioIcon, RefreshCwIcon, SunIcon, ThermometerIcon, WavesIcon, WrenchIcon, ZapIcon, ActivityIcon, BoxesIcon } from 'lucide-react';
import { categories, CONTACT } from '../../data/modalities';
import { SectionHeading } from './SectionHeading';
const icons: Record<string, ComponentType<{
  className?: string;
}>> = {
  'class-iv-laser': ZapIcon,
  shockwave: ActivityIcon,
  heit: RadioIcon,
  led: SunIcon,
  thermal: ThermometerIcon,
  'deep-oscillation': WavesIcon,
  'used-equipment': RefreshCwIcon,
  concierge: BoxesIcon,
  'neuro-reformer': WrenchIcon,
  regenmedix: WrenchIcon
};
function EquipmentPanel({
  id,
  Icon
}: {
  id: string;
  Icon: ComponentType<{
    className?: string;
  }>;
}) {
  const label = id === 'used-equipment' ? 'PRE-OWNED' : id === 'concierge' ? 'CURATED SYSTEM' : id === 'neuro-reformer' || id === 'regenmedix' ? 'UPCOMING' : 'TECHNOLOGY';
  return <div className="relative flex aspect-[4/3] items-center justify-center overflow-hidden bg-slate-50" data-id="element-112" data-mp="2c4vzpm2nc3d2">
      <div className="absolute inset-x-8 top-1/2 h-px bg-teal/25" data-id="element-113" data-mp="27b9zitdo5ry5" />
      <div className="absolute left-1/2 top-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2 rounded-full border border-navy/10" data-id="element-114" data-mp="22ejjg61v6wcq" />
      <div className="absolute left-1/2 top-1/2 h-20 w-20 -translate-x-1/2 -translate-y-1/2 rounded-full border border-teal/40" data-id="element-115" data-mp="1ydr7h51lydcr" />
      <div className="absolute flex h-20 w-28 items-center justify-center rounded-2xl border border-navy/15 bg-white shadow-sm" data-id="element-116" data-mp="2q32q6h59n12p">
        <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-navy text-teal-light" data-id="element-117" data-mp="2m0pllw29997i">
          <Icon className="h-7 w-7" data-id="element-118" data-mp="2h1cp0jll0nrq" />
        </div>
      </div>
      <span className="absolute bottom-5 text-[10px] font-semibold tracking-[0.18em] text-navy/55" data-id="element-119" data-mp="1amc3l7u6nnze">
        {label}
      </span>
      <span className="absolute left-8 top-7 h-2 w-2 rounded-full bg-teal" data-id="element-120" data-mp="15mzeshjr46u6" />
      <span className="absolute right-9 top-10 h-1.5 w-1.5 rounded-full bg-navy/30" data-id="element-121" data-mp="174o18jbj59cm" />
    </div>;
}
export function Categories() {
  return <section id="products" className="w-full bg-white py-20 sm:py-24" data-id="element-122" data-mp="1c26f8o4emerh">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-123" data-mp="y4hr97f1iri7">
        <SectionHeading eyebrow="Product Categories" title="Technologies to understand before you invest" description="Start with the category, then call JAG to compare product families, practical fit, training needs, and implementation considerations." data-id="element-124" data-mp="y5su950nvv89" />
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-125" data-mp="t6pzqeib57ej">
          {categories.map(category => {
          const Icon = icons[category.id] ?? ZapIcon;
          return <article key={category.id} className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_2px_20px_-8px_rgba(26,27,75,0.14)] transition-[transform,border-color,box-shadow] duration-200 hover:-translate-y-1 hover:border-teal/40 hover:shadow-[0_18px_40px_-16px_rgba(26,27,75,0.25)]" data-id="element-126" data-mp="jf3k85yxsm5z">
                {category.image ? <div className="relative aspect-[4/3] overflow-hidden bg-slate-50" data-id="element-127" data-mp="3vyfvebkqn0kp">
                    <img src={category.image} alt={category.name} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" data-id="element-128" data-mp="3vw395m7y641u" />
                  </div> : <EquipmentPanel id={category.id} Icon={Icon} data-id="element-129" data-mp="4qag1jyyp5y9" />}
                <div className="flex flex-1 flex-col p-6" data-id="element-130" data-mp="jg7wteukatdf">
                  <div className="flex items-start justify-between gap-3" data-id="element-131" data-mp="ehoedof6fzpt">
                    <div className="flex items-center gap-2.5" data-id="element-132" data-mp="shfvhy0zpw81">
                      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-teal/10 text-teal" data-id="element-133" data-mp="sfmnofen55yg">
                        <Icon className="h-[18px] w-[18px]" data-id="element-134" data-mp="ngrvimusa51o" />
                      </span>
                      <h3 className="font-display text-[17px] font-bold leading-tight text-navy" data-id="element-135" data-mp="2hwqiduvv4cxo">
                        {category.name}
                      </h3>
                    </div>
                    {category.status && <span className="rounded-full bg-teal/10 px-2 py-1 text-[9px] font-semibold uppercase tracking-wide text-teal" data-id="element-136" data-mp="2vqrc2a7yj9r6">
                        Coming soon
                      </span>}
                  </div>
                  <p className="mt-3 text-[13.5px] leading-relaxed text-charcoal/75" data-id="element-137" data-mp="23zlgm736m088">
                    {category.detail}
                  </p>
                  <p className="mt-4 text-[11px] font-medium leading-relaxed text-slate-500" data-id="element-138" data-mp="2czi2y223mn04">
                    {category.products.join(' · ')}
                  </p>
                  <a href={CONTACT.phoneHref} className="mt-5 inline-flex items-center gap-2 text-[13px] font-semibold text-navy transition-colors hover:text-teal focus-visible:outline-none focus-visible:text-teal" data-id="element-139" data-mp="3jhwrwpdwe21h">
                    <PhoneIcon className="h-4 w-4" data-id="element-140" data-mp="3tkahqyq85q0k" />
                    Call About This Category
                  </a>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}